import { ConnectedPosition } from "@angular/cdk/overlay";
import { Type } from "@angular/core";

export type PopoverTrigger = "click" | "hover";

export interface PopoverConfig {
  trigger?: PopoverTrigger;
  positions?: ConnectedPosition[];
  panelClass?: string;
  disabled?: boolean;
}

export interface PopoverBodyDefinition {
  content?: string;
  bodyComponent?: Type<unknown>;
  bodyInputs?: Record<string, unknown>;
}

export const DEFAULT_POPOVER_POSITIONS: ConnectedPosition[] = [
  {
    originX: "center",
    originY: "bottom",
    overlayX: "center",
    overlayY: "top",
    offsetY: 8,
  },
  {
    originX: "center",
    originY: "top",
    overlayX: "center",
    overlayY: "bottom",
    offsetY: -8,
  },
  {
    originX: "end",
    originY: "center",
    overlayX: "start",
    overlayY: "center",
    offsetX: 8,
  },
  {
    originX: "start",
    originY: "center",
    overlayX: "end",
    overlayY: "center",
    offsetX: -8,
  },
];
